import React, { useEffect, useLayoutEffect, useState, useRef } from "react";
import {
  Menu,
  MenuList,
  MenuButton,
} from "@reach/menu-button";
import "@reach/menu-button/styles.css";

const simulateMouseClick = (targetNode: any) => {
  const clickEvent = document.createEvent("MouseEvents");
  clickEvent.initEvent("mousedown", true, true);
  targetNode.focus();
  targetNode.dispatchEvent(clickEvent);
};

const MouseOverMenuButton = (props: any) => {
  const {
    menuButtonClass,
    menuButtonContent,
    menuListClass,
    menuListContent,
    onOpen,
    onClose,
    childClicked,
  } = props;

  let [isOverButton, setIsOverButton] = useState(false);
  let [isOverList, setIsOverList] = useState(false);
  let [isOpen, setIsOpen] = useState(false);
  let [isTouchInput, setIsTouchInput] = useState(false);
  let [hasClicked, setHasClicked] = useState(false);
  let button = useRef(null);

  useLayoutEffect(() => {
    // Detect mouse out and click of children...
    if (isOpen && !isOverButton && !isOverList && !isTouchInput) {
      // Simulate a click to close the menu if we hovered out of it.
      // Otherwise we toggle it back open after the child click closed it.
      if (!childClicked && button && button.current) {
        simulateMouseClick(button.current);
      }
      setIsOpen(false);
    } else if (!isOpen && (isOverButton || isOverList) && !isTouchInput) {
      if (button && button.current) {
        simulateMouseClick(button.current);
      }
      setIsOpen(true);
    }
  }, [isOverButton, isOverList]);

  useEffect(() => {
    setIsTouchInput(false);
    setHasClicked(false);
  }, [hasClicked]);

  useEffect(() => {
    if (isOpen && onOpen) {
      onOpen(isOpen);
    } else if (!isOpen && onClose) {
      onClose(isOpen);
    }
  }, [isOpen, onOpen, onClose]);

  // If these are MenuLinks that use 'as={AppLink}' then we lose their magic highlighting and selections mangament.  Need to know how valuable these are.
  return (
    <Menu>
      <MenuButton
        className={menuButtonClass}
        onTouchStart={() => setIsTouchInput(true)}
        onMouseEnter={() => setIsOverButton(true)}
        onMouseLeave={() => setIsOverButton(false)}
        onClick={() => {
          setHasClicked(true);
          setIsOpen(false);
        }}
        onKeyDown={() => setIsOpen(false)}
        ref={button}
      >
        {menuButtonContent}
      </MenuButton>
      <MenuList
        className={menuListClass}
        onMouseEnter={() => {
          if (isOpen) {
            setIsOverList(true);
          }
        }}
        onMouseLeave={() => setIsOverList(false)}
      >
        {menuListContent}
      </MenuList>
    </Menu>
  );
};

export default React.memo(MouseOverMenuButton);
